// The browser keeps the public API. Only trusted server configuration can select
// a private backend; caller cookies and Hasura authorization remain unchanged.
export function apiBase(config, server = true) {
 return String((server && config.INTERNAL_API_BASE_URL) || config.public.API_BASE_URL).replace(/\/+$/, '');
}
